/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable } from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {ReportPageInterface} from '../model/interface/report.page';
import {InvalidFormModal} from '../components/pages/report/modals';

@Injectable()
export class FormValidationGuard implements CanDeactivate<ReportPageInterface> {
  invalidFormDialog: BsModalRef;

  constructor(
    private modalService: BsModalService
  ) {}

  canDeactivate(component: ReportPageInterface, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    if (currentState.url.startsWith('/report/')) {
      if (!component.canBeSkipped()) {
        // Checking if Form has Invalid Fields
        if (!component.isFormValid()) {
          // If Invalid Fields found, show Errors
          component.showInvalidFields();

          // Show Form Invalid Popup
          this.invalidFormDialog = this.modalService.show(InvalidFormModal);
          const confirmSubject = new Subject<boolean>();
          this.invalidFormDialog.content.subject = confirmSubject;

          confirmSubject.subscribe(() => {
            return false;
          });
        }
      } else {
        return true;
      }
    } else {
      return true;
    }
  }
}
